import { render, staticRenderFns } from "./ContactUpdate.vue?vue&type=template&id=57eda48e&scoped=true&"
import script from "./ContactUpdate.vue?vue&type=script&lang=js&"
export * from "./ContactUpdate.vue?vue&type=script&lang=js&"
import style1 from "./ContactUpdate.vue?vue&type=style&index=1&id=57eda48e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eda48e",
  null
  
)

export default component.exports